/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import clsx from 'clsx';
import type { RunningExperimentSummary } from '@nab/types';

/**
 * Internal dependencies
 */
import { AlternativeExperiment } from '../alternative-experiment';
import { HeatmapExperiment } from '../heatmap-experiment';
import './style.scss';

export type OverviewExperimentsList = {
	readonly experiments: ReadonlyArray< RunningExperimentSummary >;
	readonly heatmaps: ReadonlyArray< RunningExperimentSummary >;
};

export const OverviewExperimentsList = ( {
	experiments,
	heatmaps,
}: OverviewExperimentsList ): JSX.Element | null => {
	if ( ! ( experiments.length + heatmaps.length ) ) {
		// NOTE. This should not actually happen.
		return null;
	}

	return (
		<>
			{ !! experiments.length && !! heatmaps.length && (
				<h2>{ _x( 'Split Tests', 'text', 'nelio-ab-testing' ) }</h2>
			) }

			{ !! experiments.length && (
				<div
					className={ clsx( 'nab-extended-running-experiments', {
						'nab-extended-running-experiments--single':
							1 === experiments.length,
					} ) }
				>
					{ experiments.map( ( { id, type, name } ) => (
						<AlternativeExperiment
							key={ id }
							id={ id }
							type={ type }
							name={ name }
						/>
					) ) }
				</div>
			) }

			{ !! experiments.length && !! heatmaps.length && (
				<h2>{ _x( 'Heatmaps', 'text', 'nelio-ab-testing' ) }</h2>
			) }

			{ !! heatmaps.length && (
				<div
					className={ clsx( 'nab-extended-running-heatmaps', {
						'nab-extended-running-heatmaps--single':
							1 === heatmaps.length,
					} ) }
				>
					{ heatmaps.map( ( { id, name } ) => (
						<HeatmapExperiment key={ id } id={ id } name={ name } />
					) ) }
				</div>
			) }
		</>
	);
};
